import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/veteran-facing-services-tools/veteran-facing-services-tools/packages/documentation/src/layouts/SidebarLayout.jsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "build-and-deploy-process-flows"
    }}>{`Build and deploy process flows`}</h1>
    <div className="deprecation-message">
  <h2>We're moving our docs!</h2>
  <h3>
    Find{" "}
    <a href="https://depo-platform-documentation.scrollhelp.site/developer-docs/Build-and-deploy-process-flows.1844346924.html">
      the latest version of this page
    </a>{" "}
    on the Platform website.
  </h3>
  <h3>
    Still can't find what you're looking for? Reach out to{" "}
    <a href="https://dsva.slack.com/archives/CBU0KDSB1">
      #vfs-platform-support
    </a>{" "}
    on Slack.
  </h3>
    </div>
    <p>{`Here you'll find flow diagrames for the different types of build and deploy flows we have for VA.gov. Those different flows are:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#standard-masterpr-build"
        }}>{`Standard main/PR build`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#content-only-build-and-deploy"
        }}>{`Content only build and deploy`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#daily-deploy"
        }}>{`Daily deploy`}</a></li>
    </ul>
    <h2 {...{
      "id": "standard-mainpr-build"
    }}>{`Standard main/PR build`}</h2>
    <p>{`This is the typical Jenkins build for any vets-website branch. There is some logic that is different between main and other branches:`}</p>
    <div {...{
      "className": "mermaid",
      "data-processed": "true"
    }}><svg parentName="div" {...{
        "id": "mermaid-1687453684984",
        "width": "100%",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlnsXLink": "http://www.w3.org/1999/xlink",
        "height": "1094.660888671875",
        "style": {
          "maxWidth": "615.296875px"
        },
        "viewBox": "0 0 615.296875 1094.660888671875"
      }}><style parentName="svg">{`#mermaid-1687453684984 {font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;fill:#333;}#mermaid-1687453684984 .error-icon{fill:#552222;}#mermaid-1687453684984 .error-text{fill:#552222;stroke:#552222;}#mermaid-1687453684984 .edge-thickness-normal{stroke-width:2px;}#mermaid-1687453684984 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1687453684984 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1687453684984 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1687453684984 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1687453684984 .marker{fill:#333333;stroke:#333333;}#mermaid-1687453684984 .marker.cross{stroke:#333333;}#mermaid-1687453684984 svg{font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;}#mermaid-1687453684984 .label{font-family:"trebuchet ms",verdana,arial,sans-serif;color:#333;}#mermaid-1687453684984 .cluster-label text{fill:#333;}#mermaid-1687453684984 .cluster-label span{color:#333;}#mermaid-1687453684984 .label text,#mermaid-1687453684984 span{fill:#333;color:#333;}#mermaid-1687453684984 .node rect,#mermaid-1687453684984 .node circle,#mermaid-1687453684984 .node ellipse,#mermaid-1687453684984 .node polygon,#mermaid-1687453684984 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-1687453684984 .node .label{text-align:center;}#mermaid-1687453684984 .node.clickable{cursor:pointer;}#mermaid-1687453684984 .arrowheadPath{fill:#333333;}#mermaid-1687453684984 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-1687453684984 .flowchart-link{stroke:#333333;fill:none;}#mermaid-1687453684984 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-1687453684984 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-1687453684984 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-1687453684984 .cluster text{fill:#333;}#mermaid-1687453684984 .cluster span{color:#333;}#mermaid-1687453684984 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-1687453684984 :root{--mermaid-font-family:"trebuchet ms",verdana,arial,sans-serif;}`}</style><g parentName="svg"><g parentName="g" {...{
            "className": "output"
          }}><g parentName="g" {...{
              "className": "clusters"
            }}></g><g parentName="g" {...{
              "className": "edgePaths"
            }}><g parentName="g" {...{
                "className": "edgePath LS-1 LE-2",
                "id": "L-1-2",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M289.421875,36.11905928466438L257.8203125,41.93254940388699C226.21875,47.746039523109594,163.015625,59.373019761554794,131.4140625,69.35317654744406C99.8125,79.33333333333333,99.8125,87.66666666666667,99.8125,91.83333333333333L99.8125,96",
                  "markerEnd": "url(#arrowhead69)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead69",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-1 LE-3",
                "id": "L-1-3",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M339.66352982954544,46L339.8107540246212,50.166666666666664C339.95797821969694,54.333333333333336,340.2524266098485,62.666666666666664,340.39965080492425,71C340.546875,79.33333333333333,340.546875,87.66666666666667,340.546875,91.83333333333333L340.546875,96",
                  "markerEnd": "url(#arrowhead70)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead70",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-1 LE-4",
                "id": "L-1-4",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M388.5625,37.41638683680323L415.19921875,43.01365569733602C441.8359375,48.61092455786882,495.109375,59.80546227893441,521.74609375,69.56939780613386C548.3828125,79.33333333333333,548.3828125,87.66666666666667,548.3828125,91.83333333333333L548.3828125,96",
                  "markerEnd": "url(#arrowhead71)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead71",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-2 LE-5",
                "id": "L-2-5",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M99.8125,134L99.8125,138.16666666666666C99.8125,142.33333333333334,99.8125,150.66666666666666,122.85026041666667,159.04403842409295C145.88802083333334,167.42141018151924,191.96354166666666,175.84282036303844,215.00130208333334,180.05352545379807L238.0390625,184.26423054455768",
                  "markerEnd": "url(#arrowhead72)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead72",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-3 LE-5",
                "id": "L-3-5",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M340.546875,134L340.546875,138.16666666666666C340.546875,142.33333333333334,340.546875,150.66666666666666,340.546875,159C340.546875,167.33333333333334,340.546875,175.66666666666666,340.546875,179.83333333333334L340.546875,184",
                  "markerEnd": "url(#arrowhead73)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead73",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-4 LE-5",
                "id": "L-4-5",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M548.3828125,134L548.3828125,138.16666666666666C548.3828125,142.33333333333334,548.3828125,150.66666666666666,528.7013790246211,159C509.01994554924244,167.33333333333334,469.6570785984848,175.66666666666666,449.975645123106,179.83333333333334L430.29421164772725,184",
                  "markerEnd": "url(#arrowhead74)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead74",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-5 LE-6",
                "id": "L-5-6",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M251.0643643465909,222L231.4410067471591,226.16666666666666C211.81764914772725,230.33333333333334,172.57093394886363,238.66666666666666,152.9475763494318,247C133.32421875,255.33333333333334,133.32421875,263.6666666666667,133.32421875,267.8333333333333L133.32421875,272",
                  "markerEnd": "url(#arrowhead75)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead75",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-5 LE-7",
                "id": "L-5-7",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M332.9580078125,222L331.2937825520833,226.16666666666666C329.6295572916667,230.33333333333334,326.3011067708333,238.66666666666666,324.6368815104167,247C322.97265625,255.33333333333334,322.97265625,263.6666666666667,322.97265625,267.8333333333333L322.97265625,272",
                  "markerEnd": "url(#arrowhead76)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead76",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-5 LE-8",
                "id": "L-5-8",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M416.1943359375,222L432.78369140625,226.16666666666666C449.373046875,230.33333333333334,482.5517578125,238.66666666666666,499.14111328125,247C515.73046875,255.33333333333334,515.73046875,263.6666666666667,515.73046875,267.8333333333333L515.73046875,272",
                  "markerEnd": "url(#arrowhead77)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead77",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-6 LE-9",
                "id": "L-6-9",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M133.32421875,310L133.32421875,314.1666666666667C133.32421875,318.3333333333333,133.32421875,326.6666666666667,155.33528645833334,335.54231638525386C177.34635416666666,344.417966103841,221.36848958333334,353.835932207682,243.37955729166666,358.54491525960253L265.390625,363.2538983115231",
                  "markerEnd": "url(#arrowhead78)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead78",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-7 LE-9",
                "id": "L-7-9",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M322.97265625,310L322.97265625,314.1666666666667C322.97265625,318.3333333333333,322.97265625,326.6666666666667,324.48965731534093,335C326.0066583806818,343.3333333333333,329.0406605113636,351.6666666666667,330.55766157670456,355.8333333333333L332.07466264204544,360",
                  "markerEnd": "url(#arrowhead79)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead79",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-8 LE-9",
                "id": "L-8-9",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M515.73046875,310L515.73046875,314.1666666666667C515.73046875,318.3333333333333,515.73046875,326.6666666666667,498.541015625,335.112745423067C481.3515625,343.55882417946736,446.97265625,352.11764835893473,429.783203125,356.39706044866836L412.59375,360.67647253840204",
                  "markerEnd": "url(#arrowhead80)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead80",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-9 LE-10",
                "id": "L-9-10",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M373.69282670454544,398L381.3026160037878,402.1666666666667C388.9124053030303,406.3333333333333,404.1319839015152,414.6666666666667,411.74177320075756,423C419.3515625,431.3333333333333,419.3515625,439.6666666666667,419.3515625,443.8333333333333L419.3515625,448",
                  "markerEnd": "url(#arrowhead81)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead81",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-9 LE-11",
                "id": "L-9-11",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M291.4280894886364,398L280.9973662405303,402.1666666666667C270.56664299242425,406.3333333333333,249.70519649621212,414.6666666666667,239.2744732481061,423C228.84375,431.3333333333333,228.84375,439.6666666666667,228.84375,443.8333333333333L228.84375,448",
                  "markerEnd": "url(#arrowhead82)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead82",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-11 LE-12",
                "id": "L-11-12",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M228.84375,486L228.84375,490.1666666666667C228.84375,494.3333333333333,228.84375,502.6666666666667,239.2744732481061,511C249.70519649621212,519.3333333333334,270.56664299242425,527.6666666666666,280.9973662405303,531.8333333333334L291.4280894886364,536",
                  "markerEnd": "url(#arrowhead83)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead83",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-10 LE-12",
                "id": "L-10-12",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M419.3515625,486L419.3515625,490.1666666666667C419.3515625,494.3333333333333,419.3515625,502.6666666666667,411.74177320075756,511C404.1319839015152,519.3333333333334,388.9124053030303,527.6666666666666,381.3026160037878,531.8333333333334L373.69282670454544,536",
                  "markerEnd": "url(#arrowhead84)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead84",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-12 LE-13",
                "id": "L-12-13",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M338.9921875,574L338.9921875,578.1666666666666C338.9921875,582.3333333333334,338.9921875,590.6666666666666,339.0755208333333,599.0833335876465C339.1588541666667,607.5000005086263,339.3255208333333,616.0000010172524,339.4088541666667,620.2500012715656L339.4921875,624.5000015258787",
                  "markerEnd": "url(#arrowhead85)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead85",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-13 LE-14",
                "id": "L-13-14",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M372.8902719798228,753.7628545460561L380.6338203998523,764.9125345297538C388.37736881988184,776.0622145134515,403.8644656599409,798.3615744808468,411.6080140799705,815.1779211312111C419.3515625,831.9942677815756,419.3515625,843.3276011149088,419.3515625,848.9942677815756L419.3515625,854.6609344482422",
                  "markerEnd": "url(#arrowhead86)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead86",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-14 LE-15",
                "id": "L-14-15",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M419.3515625,892.6609344482422L419.3515625,898.3276011149088C419.3515625,903.9942677815756,419.3515625,915.3276011149088,419.3515625,926.6609344482422C419.3515625,937.9942677815756,419.3515625,949.3276011149088,419.3515625,954.9942677815756L419.3515625,960.6609344482422",
                  "markerEnd": "url(#arrowhead87)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead87",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-13 LE-16",
                "id": "L-13-16",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M302.76923832643695,750.4379868005581L292.9821777720308,762.1418114085054C283.1951172176246,773.8456360164528,263.62099610881234,797.2532852323475,253.83393555440617,817.7904431736282C244.046875,838.3276011149088,244.046875,855.9942677815756,244.046875,873.6609344482422C244.046875,891.3276011149088,244.046875,908.9942677815756,244.046875,926.6609344482422C244.046875,944.3276011149088,244.046875,961.9942677815756,244.046875,978.1609344482422C244.046875,994.3276011149088,244.046875,1008.9942677815756,255.01692708333334,1021.4113938684128C265.9869791666667,1033.8285199552502,287.9270833333333,1043.996105462258,298.8971354166667,1049.079898215762L309.8671875,1054.1636909692659",
                  "markerEnd": "url(#arrowhead88)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead88",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-15 LE-16",
                "id": "L-15-16",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M419.3515625,998.6609344482422L419.3515625,1002.8276011149088C419.3515625,1006.9942677815756,419.3515625,1015.3276011149088,410.8125,1024.1697490182078C402.2734375,1033.0118969215068,385.1953125,1042.3628593947715,376.65625,1047.0383406314038L368.1171875,1051.7138218680361",
                  "markerEnd": "url(#arrowhead89)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead89",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g></g><g parentName="g" {...{
              "className": "edgeLabels"
            }}><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-1-2",
                        "className": "edgeLabel L-LS-1' L-LE-2"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-1-3",
                        "className": "edgeLabel L-LS-1' L-LE-3"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-1-4",
                        "className": "edgeLabel L-LS-1' L-LE-4"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-2-5",
                        "className": "edgeLabel L-LS-2' L-LE-5"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-3-5",
                        "className": "edgeLabel L-LS-3' L-LE-5"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-4-5",
                        "className": "edgeLabel L-LS-4' L-LE-5"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-5-6",
                        "className": "edgeLabel L-LS-5' L-LE-6"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-5-7",
                        "className": "edgeLabel L-LS-5' L-LE-7"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-5-8",
                        "className": "edgeLabel L-LS-5' L-LE-8"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-6-9",
                        "className": "edgeLabel L-LS-6' L-LE-9"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-7-9",
                        "className": "edgeLabel L-LS-7' L-LE-9"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-8-9",
                        "className": "edgeLabel L-LS-8' L-LE-9"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-9-10",
                        "className": "edgeLabel L-LS-9' L-LE-10"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-9-11",
                        "className": "edgeLabel L-LS-9' L-LE-11"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-11-12",
                        "className": "edgeLabel L-LS-11' L-LE-12"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-10-12",
                        "className": "edgeLabel L-LS-10' L-LE-12"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-12-13",
                        "className": "edgeLabel L-LS-12' L-LE-13"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "translate(419.3515625,820.6609344482422)",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(-13.0546875,-9)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "26.109375",
                    "height": "18"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "26.109375",
                    "height": "18"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-13-14",
                        "className": "edgeLabel L-LS-13' L-LE-14"
                      }}>{`Yes`}</span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-14-15",
                        "className": "edgeLabel L-LS-14' L-LE-15"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "translate(244.046875,926.6609344482422)",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(-10.2265625,-9)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "20.453125",
                    "height": "18"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "20.453125",
                    "height": "18"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-13-16",
                        "className": "edgeLabel L-LS-13' L-LE-16"
                      }}>{`No`}</span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-15-16",
                        "className": "edgeLabel L-LS-15' L-LE-16"
                      }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
              "className": "nodes"
            }}><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-1-43",
                "transform": "translate(338.9921875,27)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "5",
                  "ry": "5",
                  "x": "-49.5703125",
                  "y": "-19",
                  "width": "99.140625",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-39.5703125,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "79.140625",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Build starts`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-2-45",
                "transform": "translate(99.8125,115)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-91.8125",
                  "y": "-19",
                  "width": "183.625",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-81.8125,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "163.625",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Check for linter failures`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-3-47",
                "transform": "translate(340.546875,115)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-98.921875",
                  "y": "-19",
                  "width": "197.84375",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-88.921875,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "177.84375",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Check for security issues`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-4-49",
                "transform": "translate(548.3828125,115)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-58.9140625",
                  "y": "-19",
                  "width": "117.828125",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-48.9140625,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "97.828125",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Run unit tests`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-5-51",
                "transform": "translate(340.546875,203)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "5",
                  "ry": "5",
                  "x": "-102.5078125",
                  "y": "-19",
                  "width": "205.015625",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-92.5078125,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "185.015625",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Build site and applications`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-6-57",
                "transform": "translate(133.32421875,291)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-63.375",
                  "y": "-19",
                  "width": "126.75",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-53.375,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "106.75",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`vagovdev build`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-7-59",
                "transform": "translate(322.97265625,291)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-76.2734375",
                  "y": "-19",
                  "width": "152.546875",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-66.2734375,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "132.546875",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`vagovstaging build`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-8-61",
                "transform": "translate(515.73046875,291)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-66.484375",
                  "y": "-19",
                  "width": "132.96875",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-56.484375,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "112.96875",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`vagovprod build`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-9-63",
                "transform": "translate(338.9921875,379)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "5",
                  "ry": "5",
                  "x": "-73.6015625",
                  "y": "-19",
                  "width": "147.203125",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-63.6015625,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "127.203125",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Integration testing`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-10-69",
                "transform": "translate(419.3515625,467)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-72.6875",
                  "y": "-19",
                  "width": "145.375",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-62.6875,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "125.375",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Accessibility tests`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-11-71",
                "transform": "translate(228.84375,467)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-67.8203125",
                  "y": "-19",
                  "width": "135.640625",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-57.8203125,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "115.640625",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`End to end tests`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-12-73",
                "transform": "translate(338.9921875,555)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-179",
                  "y": "-19",
                  "width": "358",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-169,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "338",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Create archives for each build and upload to S3`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-13-77",
                "transform": "translate(338.9921875,705.3304672241211)",
                "style": {
                  "opacity": "1"
                }
              }}><polygon parentName="g" {...{
                  "points": "81.33046875000001,0 162.66093750000002,-81.33046875000001 81.33046875000001,-162.66093750000002 0,-81.33046875000001",
                  "transform": "translate(-81.33046875000001,81.33046875000001)",
                  "className": "label-container"
                }}></polygon><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-61.3671875,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "122.734375",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`On main branch?`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-14-79",
                "transform": "translate(419.3515625,873.6609344482422)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-140.3046875",
                  "y": "-19",
                  "width": "280.609375",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-130.3046875,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "260.609375",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Cache Drupal content and files to S3`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-15-81",
                "transform": "translate(419.3515625,979.6609344482422)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-125.6328125",
                  "y": "-19",
                  "width": "251.265625",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-115.6328125,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "231.265625",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Deploy builds to dev and staging`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-16-83",
                "transform": "translate(338.9921875,1067.6609344482422)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "5",
                  "ry": "5",
                  "x": "-29.125",
                  "y": "-19",
                  "width": "58.25",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-19.125,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "38.25",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Done`}</div></foreignObject></g></g></g></g></g></g></svg></div>
    <h2 {...{
      "id": "content-only-deploy"
    }}>{`Content only deploy`}</h2>
    <p>{`When content is changed in Drupal, sometimes we need to publish it immediately on a va.gov site. There are two separate processes for this, one for staging/dev and another for production.`}</p>
    <h3 {...{
      "id": "stagingdev-content-deploy"
    }}>{`Staging/dev content deploy`}</h3>
    <div {...{
      "className": "mermaid",
      "data-processed": "true"
    }}><svg parentName="div" {...{
        "id": "mermaid-1687453684388",
        "width": "100%",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlnsXLink": "http://www.w3.org/1999/xlink",
        "height": "582",
        "style": {
          "maxWidth": "536.390625px"
        },
        "viewBox": "0 0 536.390625 582"
      }}><style parentName="svg">{`#mermaid-1687453684388 {font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;fill:#333;}#mermaid-1687453684388 .error-icon{fill:#552222;}#mermaid-1687453684388 .error-text{fill:#552222;stroke:#552222;}#mermaid-1687453684388 .edge-thickness-normal{stroke-width:2px;}#mermaid-1687453684388 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1687453684388 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1687453684388 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1687453684388 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1687453684388 .marker{fill:#333333;stroke:#333333;}#mermaid-1687453684388 .marker.cross{stroke:#333333;}#mermaid-1687453684388 svg{font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;}#mermaid-1687453684388 .label{font-family:"trebuchet ms",verdana,arial,sans-serif;color:#333;}#mermaid-1687453684388 .cluster-label text{fill:#333;}#mermaid-1687453684388 .cluster-label span{color:#333;}#mermaid-1687453684388 .label text,#mermaid-1687453684388 span{fill:#333;color:#333;}#mermaid-1687453684388 .node rect,#mermaid-1687453684388 .node circle,#mermaid-1687453684388 .node ellipse,#mermaid-1687453684388 .node polygon,#mermaid-1687453684388 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-1687453684388 .node .label{text-align:center;}#mermaid-1687453684388 .node.clickable{cursor:pointer;}#mermaid-1687453684388 .arrowheadPath{fill:#333333;}#mermaid-1687453684388 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-1687453684388 .flowchart-link{stroke:#333333;fill:none;}#mermaid-1687453684388 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-1687453684388 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-1687453684388 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-1687453684388 .cluster text{fill:#333;}#mermaid-1687453684388 .cluster span{color:#333;}#mermaid-1687453684388 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-1687453684388 :root{--mermaid-font-family:"trebuchet ms",verdana,arial,sans-serif;}`}</style><g parentName="svg"><g parentName="g" {...{
            "className": "output"
          }}><g parentName="g" {...{
              "className": "clusters"
            }}></g><g parentName="g" {...{
              "className": "edgePaths"
            }}><g parentName="g" {...{
                "className": "edgePath LS-1 LE-2",
                "id": "L-1-2",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M268.1953125,46L268.1953125,50.166666666666664C268.1953125,54.333333333333336,268.1953125,62.666666666666664,268.1953125,71C268.1953125,79.33333333333333,268.1953125,87.66666666666667,268.1953125,91.83333333333333L268.1953125,96",
                  "markerEnd": "url(#arrowhead32)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead32",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-2 LE-3",
                "id": "L-2-3",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M268.1953125,134L268.1953125,138.16666666666666C268.1953125,142.33333333333334,268.1953125,150.66666666666666,268.1953125,159C268.1953125,167.33333333333334,268.1953125,175.66666666666666,268.1953125,179.83333333333334L268.1953125,184",
                  "markerEnd": "url(#arrowhead33)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead33",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-3 LE-4",
                "id": "L-3-4",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M268.1953125,222L268.1953125,226.16666666666666C268.1953125,230.33333333333334,268.1953125,238.66666666666666,268.1953125,247C268.1953125,255.33333333333334,268.1953125,263.6666666666667,268.1953125,267.8333333333333L268.1953125,272",
                  "markerEnd": "url(#arrowhead34)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead34",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-4 LE-5",
                "id": "L-4-5",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M268.1953125,310L268.1953125,314.1666666666667C268.1953125,318.3333333333333,268.1953125,326.6666666666667,268.1953125,335C268.1953125,343.3333333333333,268.1953125,351.6666666666667,268.1953125,355.8333333333333L268.1953125,360",
                  "markerEnd": "url(#arrowhead35)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead35",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-5 LE-6",
                "id": "L-5-6",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M268.1953125,398L268.1953125,402.1666666666667C268.1953125,406.3333333333333,268.1953125,414.6666666666667,268.1953125,423C268.1953125,431.3333333333333,268.1953125,439.6666666666667,268.1953125,443.8333333333333L268.1953125,448",
                  "markerEnd": "url(#arrowhead36)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead36",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-6 LE-7",
                "id": "L-6-7",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M268.1953125,486L268.1953125,490.1666666666667C268.1953125,494.3333333333333,268.1953125,502.6666666666667,268.1953125,511C268.1953125,519.3333333333334,268.1953125,527.6666666666666,268.1953125,531.8333333333334L268.1953125,536",
                  "markerEnd": "url(#arrowhead37)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead37",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g></g><g parentName="g" {...{
              "className": "edgeLabels"
            }}><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-1-2",
                        "className": "edgeLabel L-LS-1' L-LE-2"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-2-3",
                        "className": "edgeLabel L-LS-2' L-LE-3"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-3-4",
                        "className": "edgeLabel L-LS-3' L-LE-4"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-4-5",
                        "className": "edgeLabel L-LS-4' L-LE-5"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-5-6",
                        "className": "edgeLabel L-LS-5' L-LE-6"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-6-7",
                        "className": "edgeLabel L-LS-6' L-LE-7"
                      }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
              "className": "nodes"
            }}><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-1-13",
                "transform": "translate(268.1953125,27)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "5",
                  "ry": "5",
                  "x": "-118.5078125",
                  "y": "-19",
                  "width": "237.015625",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-108.5078125,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "217.015625",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Build started for dev or staging`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-2-15",
                "transform": "translate(268.1953125,115)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-159.828125",
                  "y": "-19",
                  "width": "319.65625",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-149.828125,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "299.65625",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Fetch build for latest main commit from S3`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-3-17",
                "transform": "translate(268.1953125,203)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-134.515625",
                  "y": "-19",
                  "width": "269.03125",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-124.515625,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "249.03125",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Build static pages with new content`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-4-19",
                "transform": "translate(268.1953125,291)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-260.1953125",
                  "y": "-19",
                  "width": "520.390625",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-250.1953125,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "500.390625",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Skip Webpack build, use assets from most recent build for applications`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-5-21",
                "transform": "translate(268.1953125,379)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-155.4296875",
                  "y": "-19",
                  "width": "310.859375",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-145.4296875,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "290.859375",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Create archive for build and upload to S3`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-6-23",
                "transform": "translate(268.1953125,467)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-140.3046875",
                  "y": "-19",
                  "width": "280.609375",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-130.3046875,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "260.609375",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Cache Drupal content and files to S3`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-7-25",
                "transform": "translate(268.1953125,555)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-115.3984375",
                  "y": "-19",
                  "width": "230.796875",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-105.3984375,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "210.796875",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Deploy build to dev or staging`}</div></foreignObject></g></g></g></g></g></g></svg></div>
    <h3 {...{
      "id": "production-content-deploy"
    }}>{`Production content deploy`}</h3>
    <div {...{
      "className": "mermaid",
      "data-processed": "true"
    }}><svg parentName="div" {...{
        "id": "mermaid-1687453684388",
        "width": "100%",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlnsXLink": "http://www.w3.org/1999/xlink",
        "height": "582",
        "style": {
          "maxWidth": "496.40625px"
        },
        "viewBox": "0 0 496.40625 582"
      }}><style parentName="svg">{`#mermaid-1687453684388 {font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;fill:#333;}#mermaid-1687453684388 .error-icon{fill:#552222;}#mermaid-1687453684388 .error-text{fill:#552222;stroke:#552222;}#mermaid-1687453684388 .edge-thickness-normal{stroke-width:2px;}#mermaid-1687453684388 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1687453684388 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1687453684388 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1687453684388 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1687453684388 .marker{fill:#333333;stroke:#333333;}#mermaid-1687453684388 .marker.cross{stroke:#333333;}#mermaid-1687453684388 svg{font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;}#mermaid-1687453684388 .label{font-family:"trebuchet ms",verdana,arial,sans-serif;color:#333;}#mermaid-1687453684388 .cluster-label text{fill:#333;}#mermaid-1687453684388 .cluster-label span{color:#333;}#mermaid-1687453684388 .label text,#mermaid-1687453684388 span{fill:#333;color:#333;}#mermaid-1687453684388 .node rect,#mermaid-1687453684388 .node circle,#mermaid-1687453684388 .node ellipse,#mermaid-1687453684388 .node polygon,#mermaid-1687453684388 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-1687453684388 .node .label{text-align:center;}#mermaid-1687453684388 .node.clickable{cursor:pointer;}#mermaid-1687453684388 .arrowheadPath{fill:#333333;}#mermaid-1687453684388 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-1687453684388 .flowchart-link{stroke:#333333;fill:none;}#mermaid-1687453684388 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-1687453684388 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-1687453684388 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-1687453684388 .cluster text{fill:#333;}#mermaid-1687453684388 .cluster span{color:#333;}#mermaid-1687453684388 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-1687453684388 :root{--mermaid-font-family:"trebuchet ms",verdana,arial,sans-serif;}`}</style><g parentName="svg"><g parentName="g" {...{
            "className": "output"
          }}><g parentName="g" {...{
              "className": "clusters"
            }}></g><g parentName="g" {...{
              "className": "edgePaths"
            }}><g parentName="g" {...{
                "className": "edgePath LS-1 LE-2",
                "id": "L-1-2",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M248.203125,46L248.203125,50.166666666666664C248.203125,54.333333333333336,248.203125,62.666666666666664,248.203125,71C248.203125,79.33333333333333,248.203125,87.66666666666667,248.203125,91.83333333333333L248.203125,96",
                  "markerEnd": "url(#arrowhead32)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead32",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-2 LE-3",
                "id": "L-2-3",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M248.203125,134L248.203125,138.16666666666666C248.203125,142.33333333333334,248.203125,150.66666666666666,248.203125,159C248.203125,167.33333333333334,248.203125,175.66666666666666,248.203125,179.83333333333334L248.203125,184",
                  "markerEnd": "url(#arrowhead33)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead33",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-3 LE-4",
                "id": "L-3-4",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M248.203125,222L248.203125,226.16666666666666C248.203125,230.33333333333334,248.203125,238.66666666666666,248.203125,247C248.203125,255.33333333333334,248.203125,263.6666666666667,248.203125,267.8333333333333L248.203125,272",
                  "markerEnd": "url(#arrowhead34)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead34",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-4 LE-5",
                "id": "L-4-5",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M248.203125,310L248.203125,314.1666666666667C248.203125,318.3333333333333,248.203125,326.6666666666667,248.203125,335C248.203125,343.3333333333333,248.203125,351.6666666666667,248.203125,355.8333333333333L248.203125,360",
                  "markerEnd": "url(#arrowhead35)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead35",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-5 LE-6",
                "id": "L-5-6",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M248.203125,398L248.203125,402.1666666666667C248.203125,406.3333333333333,248.203125,414.6666666666667,248.203125,423C248.203125,431.3333333333333,248.203125,439.6666666666667,248.203125,443.8333333333333L248.203125,448",
                  "markerEnd": "url(#arrowhead36)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead36",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-6 LE-7",
                "id": "L-6-7",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M248.203125,486L248.203125,490.1666666666667C248.203125,494.3333333333333,248.203125,502.6666666666667,248.203125,511C248.203125,519.3333333333334,248.203125,527.6666666666666,248.203125,531.8333333333334L248.203125,536",
                  "markerEnd": "url(#arrowhead37)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead37",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g></g><g parentName="g" {...{
              "className": "edgeLabels"
            }}><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-1-2",
                        "className": "edgeLabel L-LS-1' L-LE-2"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-2-3",
                        "className": "edgeLabel L-LS-2' L-LE-3"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-3-4",
                        "className": "edgeLabel L-LS-3' L-LE-4"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-4-5",
                        "className": "edgeLabel L-LS-4' L-LE-5"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-5-6",
                        "className": "edgeLabel L-LS-5' L-LE-6"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-6-7",
                        "className": "edgeLabel L-LS-6' L-LE-7"
                      }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
              "className": "nodes"
            }}><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-1-13",
                "transform": "translate(248.203125,27)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "5",
                  "ry": "5",
                  "x": "-54.46875",
                  "y": "-19",
                  "width": "108.9375",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-44.46875,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "88.9375",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Build started`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-2-15",
                "transform": "translate(248.203125,115)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-204.7578125",
                  "y": "-19",
                  "width": "409.515625",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-194.7578125,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "389.515625",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Fetch last released prod build from GitHub releases list`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-3-17",
                "transform": "translate(248.203125,203)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-134.515625",
                  "y": "-19",
                  "width": "269.03125",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-124.515625,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "249.03125",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Build static pages with new content`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-4-19",
                "transform": "translate(248.203125,291)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-240.203125",
                  "y": "-19",
                  "width": "480.40625",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-230.203125,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "460.40625",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Skip Webpack build, use assets last prod release for applications`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-5-21",
                "transform": "translate(248.203125,379)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-155.4296875",
                  "y": "-19",
                  "width": "310.859375",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-145.4296875,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "290.859375",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Create archive for build and upload to S3`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-6-23",
                "transform": "translate(248.203125,467)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-81.15625",
                  "y": "-19",
                  "width": "162.3125",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-71.15625,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "142.3125",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Deploy build to prod`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-7-25",
                "transform": "translate(248.203125,555)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-121.609375",
                  "y": "-19",
                  "width": "243.21875",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-111.609375,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "223.21875",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Deploy content preview servers`}</div></foreignObject></g></g></g></g></g></g></svg></div>
    <h2 {...{
      "id": "daily-deploy"
    }}>{`Daily deploy`}</h2>
    <div {...{
      "className": "mermaid",
      "data-processed": "true"
    }}><svg parentName="div" {...{
        "id": "mermaid-1687453684996",
        "width": "100%",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlnsXLink": "http://www.w3.org/1999/xlink",
        "height": "758",
        "style": {
          "maxWidth": "575.515625px"
        },
        "viewBox": "0 0 575.515625 758"
      }}><style parentName="svg">{`#mermaid-1687453684996 {font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;fill:#333;}#mermaid-1687453684996 .error-icon{fill:#552222;}#mermaid-1687453684996 .error-text{fill:#552222;stroke:#552222;}#mermaid-1687453684996 .edge-thickness-normal{stroke-width:2px;}#mermaid-1687453684996 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1687453684996 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1687453684996 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1687453684996 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1687453684996 .marker{fill:#333333;stroke:#333333;}#mermaid-1687453684996 .marker.cross{stroke:#333333;}#mermaid-1687453684996 svg{font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;}#mermaid-1687453684996 .label{font-family:"trebuchet ms",verdana,arial,sans-serif;color:#333;}#mermaid-1687453684996 .cluster-label text{fill:#333;}#mermaid-1687453684996 .cluster-label span{color:#333;}#mermaid-1687453684996 .label text,#mermaid-1687453684996 span{fill:#333;color:#333;}#mermaid-1687453684996 .node rect,#mermaid-1687453684996 .node circle,#mermaid-1687453684996 .node ellipse,#mermaid-1687453684996 .node polygon,#mermaid-1687453684996 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-1687453684996 .node .label{text-align:center;}#mermaid-1687453684996 .node.clickable{cursor:pointer;}#mermaid-1687453684996 .arrowheadPath{fill:#333333;}#mermaid-1687453684996 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-1687453684996 .flowchart-link{stroke:#333333;fill:none;}#mermaid-1687453684996 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-1687453684996 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-1687453684996 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-1687453684996 .cluster text{fill:#333;}#mermaid-1687453684996 .cluster span{color:#333;}#mermaid-1687453684996 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-1687453684996 :root{--mermaid-font-family:"trebuchet ms",verdana,arial,sans-serif;}`}</style><g parentName="svg"><g parentName="g" {...{
            "className": "output"
          }}><g parentName="g" {...{
              "className": "clusters"
            }}></g><g parentName="g" {...{
              "className": "edgePaths"
            }}><g parentName="g" {...{
                "className": "edgePath LS-1 LE-2",
                "id": "L-1-2",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M287.7578125,46L287.7578125,50.166666666666664C287.7578125,54.333333333333336,287.7578125,62.666666666666664,287.7578125,71C287.7578125,79.33333333333333,287.7578125,87.66666666666667,287.7578125,91.83333333333333L287.7578125,96",
                  "markerEnd": "url(#arrowhead42)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead42",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-2 LE-3",
                "id": "L-2-3",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M287.7578125,134L287.7578125,138.16666666666666C287.7578125,142.33333333333334,287.7578125,150.66666666666666,287.7578125,159C287.7578125,167.33333333333334,287.7578125,175.66666666666666,287.7578125,179.83333333333334L287.7578125,184",
                  "markerEnd": "url(#arrowhead43)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead43",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-3 LE-4",
                "id": "L-3-4",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M287.7578125,222L287.7578125,226.16666666666666C287.7578125,230.33333333333334,287.7578125,238.66666666666666,287.7578125,247C287.7578125,255.33333333333334,287.7578125,263.6666666666667,287.7578125,267.8333333333333L287.7578125,272",
                  "markerEnd": "url(#arrowhead44)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead44",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-4 LE-5",
                "id": "L-4-5",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M287.7578125,310L287.7578125,314.1666666666667C287.7578125,318.3333333333333,287.7578125,326.6666666666667,287.7578125,335C287.7578125,343.3333333333333,287.7578125,351.6666666666667,287.7578125,355.8333333333333L287.7578125,360",
                  "markerEnd": "url(#arrowhead45)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead45",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-5 LE-6",
                "id": "L-5-6",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M287.7578125,398L287.7578125,402.1666666666667C287.7578125,406.3333333333333,287.7578125,414.6666666666667,287.7578125,423C287.7578125,431.3333333333333,287.7578125,439.6666666666667,287.7578125,443.8333333333333L287.7578125,448",
                  "markerEnd": "url(#arrowhead46)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead46",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-6 LE-7",
                "id": "L-6-7",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M287.7578125,486L287.7578125,490.1666666666667C287.7578125,494.3333333333333,287.7578125,502.6666666666667,287.7578125,511C287.7578125,519.3333333333334,287.7578125,527.6666666666666,287.7578125,531.8333333333334L287.7578125,536",
                  "markerEnd": "url(#arrowhead47)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead47",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-7 LE-8",
                "id": "L-7-8",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M287.7578125,574L287.7578125,578.1666666666666C287.7578125,582.3333333333334,287.7578125,590.6666666666666,287.7578125,599C287.7578125,607.3333333333334,287.7578125,615.6666666666666,287.7578125,619.8333333333334L287.7578125,624",
                  "markerEnd": "url(#arrowhead48)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead48",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-8 LE-9",
                "id": "L-8-9",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M287.7578125,662L287.7578125,666.1666666666666C287.7578125,670.3333333333334,287.7578125,678.6666666666666,287.7578125,687C287.7578125,695.3333333333334,287.7578125,703.6666666666666,287.7578125,707.8333333333334L287.7578125,712",
                  "markerEnd": "url(#arrowhead49)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead49",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g></g><g parentName="g" {...{
              "className": "edgeLabels"
            }}><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-1-2",
                        "className": "edgeLabel L-LS-1' L-LE-2"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-2-3",
                        "className": "edgeLabel L-LS-2' L-LE-3"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-3-4",
                        "className": "edgeLabel L-LS-3' L-LE-4"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-4-5",
                        "className": "edgeLabel L-LS-4' L-LE-5"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-5-6",
                        "className": "edgeLabel L-LS-5' L-LE-6"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-6-7",
                        "className": "edgeLabel L-LS-6' L-LE-7"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-7-8",
                        "className": "edgeLabel L-LS-7' L-LE-8"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-8-9",
                        "className": "edgeLabel L-LS-8' L-LE-9"
                      }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
              "className": "nodes"
            }}><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-1-17",
                "transform": "translate(287.7578125,27)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "5",
                  "ry": "5",
                  "x": "-61.5859375",
                  "y": "-19",
                  "width": "123.171875",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-51.5859375,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "103.171875",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Deploy started`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-2-19",
                "transform": "translate(287.7578125,115)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-159.828125",
                  "y": "-19",
                  "width": "319.65625",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-149.828125,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "299.65625",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Fetch build for latest main commit from S3`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-3-21",
                "transform": "translate(287.7578125,203)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-134.515625",
                  "y": "-19",
                  "width": "269.03125",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-124.515625,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "249.03125",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Build static pages with new content`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-4-23",
                "transform": "translate(287.7578125,291)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-279.7578125",
                  "y": "-19",
                  "width": "559.515625",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-269.7578125,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "539.515625",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Skip Webpack build, use assets from most recent main build for applications`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-5-25",
                "transform": "translate(287.7578125,379)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-155.4296875",
                  "y": "-19",
                  "width": "310.859375",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-145.4296875,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "290.859375",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Create archive for build and upload to S3`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-6-27",
                "transform": "translate(287.7578125,467)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-89.59375",
                  "y": "-19",
                  "width": "179.1875",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-79.59375,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "159.1875",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Create GitHub release`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-7-29",
                "transform": "translate(287.7578125,555)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-78.6171875",
                  "y": "-19",
                  "width": "157.234375",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-68.6171875,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "137.234375",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Wait for 60 minutes`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-8-31",
                "transform": "translate(287.7578125,643)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-81.15625",
                  "y": "-19",
                  "width": "162.3125",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-71.15625,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "142.3125",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Deploy build to prod`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-9-33",
                "transform": "translate(287.7578125,731)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-121.609375",
                  "y": "-19",
                  "width": "243.21875",
                  "height": "38",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-111.609375,-9)"
                  }}><foreignObject parentName="g" {...{
                      "width": "223.21875",
                      "height": "18"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Deploy content preview servers`}</div></foreignObject></g></g></g></g></g></g></svg></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      